var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-container"},[_c('div',{staticClass:"icon-container"},[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.icon)}})],1),_c('div',{staticClass:"data-container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }